import type { UnifiedCitation } from "@memorang/types";
import type { VectorDocument } from "../types";

const mockedSourcesForDisplayTitle: Record<number, string> = {
	39: "Formula/Conversion Table",
	40: "American Water Works Association. (2016). *WSO water treatment, Grade 1*. American Water Works Association. ISBN 978-1-62576-123-1.",
	41: "American Water Works Association. (2016). *WSO water treatment, Grade 2*. American Water Works Association. ISBN 978-1-62576-124-8.",
	42: "American Water Works Association. (2016). *WSO water treatment, Grades 3 & 4*. American Water Works Association. ISBN 978-1-62576-125-5.",
	43: "American Water Works Association. (2016). *WSO water distribution, Grades 1 & 2*. American Water Works Association. ISBN 978-1-62576-126-2.",
	44: "American Water Works Association. (2016). *WSO water distribution, Grades 3 & 4*. American Water Works Association. ISBN 978-1-62576-127-9.",
	45: "American Water Works Association. (2010). *Basic science concepts and applications* (4th ed.). American Water Works Association. ISBN 978-1-58321-233-2.",
	46: "Office of Water Programs, California State University, Sacramento. (2021). *Operation and maintenance of wastewater collection systems* (Vol. 1, 8th ed.). Pearson Custom Publishing. ISBN 978-0-137-45551-5.",
	47: "Office of Water Programs, California State University, Sacramento. (2021). *Operation and maintenance of wastewater collection systems* (Vol. 2, 8th ed.). Pearson Custom Publishing. ISBN 978-0-137-45552-2.",
	48: "Office of Water Programs, California State University, Sacramento. (2019). *Operation of wastewater treatment plants* (Vol. 1, 8th ed.). Pearson Custom Publishing. ISBN 978-0-13-568400-9.",
	49: "Office of Water Programs, California State University, Sacramento. (2022). *Operation of wastewater treatment plants* (Vol. 2, 8th ed.). Pearson Custom Publishing. ISBN 978-0-137-86554-3.",
	50: "Office of Water Programs, California State University, Sacramento. (2023). *Operation of wastewater treatment plants* (Vol. 3). Pearson Custom Publishing. ISBN 978-0-13795-264-9.",
	51: "Office of Water Programs, California State University, Sacramento. (2018). *Water distribution system operation and maintenance* (7th ed.). Pearson Custom Publishing. ISBN 978-1-323-82918-9.",
	53: "Office of Water Programs, California State University, Sacramento. (2020). *Water treatment plant operation* (Vol. 2, 7th ed.). Pearson Custom Publishing. ISBN 978-0-13-666899-2.",
	54: "Water Environment Federation. (2017). *Operation of water resource recovery facilities* (7th ed., Manual of Practice No. 11). McGraw-Hill Education. ISBN 978-1-259-85936-6.",
	55: "Formula/Conversion Table",
	56: "American Water Works Association. (2003). *Water quality* (3rd ed.). American Water Works Association. ISBN 1-58321-232-9.",
	57: "Water Environment Federation & Water Professionals International. (2024). *Wastewater treatment fundamentals I: Liquid treatment* (2nd ed.). Water Environment Federation. ISBN 978-1-57278-454-3.",
	58: "Water Environment Federation & Association of Boards of Certification. (2021). *Wastewater treatment fundamentals II: Solids handling and support systems*. Water Environment Federation. ISBN 978-1-57278-361-4.",
	59: "Water Environment Federation & Water Professionals International. (2022). *Wastewater treatment fundamentals III: Advanced treatment*. Water Environment Federation. ISBN 978-1-57278-411-6.",
};
export const getShortenedText = (text: string, wordLimit = 8) => {
	const cleanedText = text.replace(/\n/g, " ");
	const words = cleanedText.split(" ");
	if (words.length > wordLimit) {
		return `${words.slice(0, wordLimit).join(" ")}...`;
	}
	return cleanedText;
};

export const getChapterTextAndSource = (reference: UnifiedCitation) => {
	const source = reference.sourceId || reference.id;
	const title = reference.title;
	const referenceText = reference.pageContent.replace("\\n", "");

	const shortenedReferenceText = getShortenedText(referenceText);

	return {
		source,
		title,
		shortenedReferenceText,
	};
};

export const formatAPACitation = (metadata: VectorDocument["metadata"]) => {
	// const author = metadata.author || "Unknown Author";
	// const year = "n.d.";
	const title =
		mockedSourcesForDisplayTitle[metadata.source_id] ||
		metadata.title ||
		"Untitled";
	// const page = metadata.page_number;
	// const publisher = metadata.publisher;

	const citation = title;
	// if (page) {
	// 	citation += ` (p. ${page})`;
	// }
	// citation += `.${publisher ? ` ${publisher}.` : ""}`;

	return citation;
};

export const convertToUnifiedCitations = (
	references: VectorDocument[],
): UnifiedCitation[] => {
	return references.map((ref) => ({
		sourceId: ref.metadata.source_id,
		title: formatAPACitation(ref.metadata),
		pageContent: ref.pageContent,
		thumbnailUri: ref.metadata.thumbnailUri,
	}));
};
